<template>
  <div>
    <div id="map"></div>
  </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster/dist/leaflet.markercluster'
import {T_STD, T_PALE, O_STD, BASEGIS} from '../util.js'
import { mapState } from 'vuex'

export default {
  data: function(){
    return {
      map: null,
      taskLayers: L.markerClusterGroup(),
      carMarkers: L.layerGroup(),
      polyLines: L.layerGroup(),
      Map_BaseLayer: {
        "地理院地図 標準": T_STD,
        "地理院地図 淡色": T_PALE,
        "地理院地図 航空写真": BASEGIS,
        "OpenStreetMap 標準": O_STD
      },
    }
  },
  props:{
    isCarShow: {
      type: Boolean,
      default: false,
    }
  },
  watch:{
    isCarShow: function(){
      this.addCarsMap()
    }
  },
  computed:{
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  mounted(){
    this.map = L.map('map',
      {
        center: L.latLng( this.user.location.lat, this.user.location.lng ),
        zoom: 15,
        layers:[ new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
            attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
          })]
      }
    )
    L.control.layers(this.Map_BaseLayer, null, {
        collapsed: true
    }).addTo(this.map)
  },
  methods:{
    createTaskPoint(task_data){
      task_data.forEach( function(e) {
        let popupElement = 
        `<div class="content">
            <p>
              <strong>${e.task_title}</strong>
              <br>
              <small>登録日：</small> <small>${e.created_at}</small>
              <br>
              <small>登録者：</small> <small>${e.register_name}</small>
              <br>
              コメント：${e.comment}
            </p>
          </div>
          <nav class="level is-mobile">
            <div class="level-left">
              <a class="level-item" aria-label="reply" href="/#/task/edit/${e.id}" target="_blank">
                <span class="icon is-small">
                  <i class="fas fa-reply" aria-hidden="true"></i>
                </span>
              </a>
              <!-- <a class="level-item" aria-label="reply">
                <span class="icon is-small">
                  <i class="fas fa-images" aria-hidden="true"></i>
                </span>
              </a> -->
            </div>
          </nav>`
        this.taskLayers.addLayer(
          L.marker(L.latLng(e.lat, e.lon), {
            icon: L.icon({
              iconUrl: e.imgUrl,
              iconSize: [48, 48],
            }),
            draggable: false,
          })
          .bindPopup(popupElement)
        )
        this.map.addLayer(this.taskLayers)
      }.bind(this))
      let message = ''
      let isError = false
      let hasError = false
      try{
        this.map.fitBounds(this.taskLayers.getBounds())
      }catch(e){
        isError = true
        hasError = true
        message = "検索結果がありません"
      }
      this.$emit('taskMessage',[isError, hasError, message])
    },
    createCars(carsDataArray){
      this.carMarkers.clearLayers()
      this.polyLines.clearLayers()
      carsDataArray.forEach(carsData => {
        let trackObj = JSON.parse(carsData.track_json)
        let settingObj = JSON.parse(carsData.settings)
        let myIcon = L.icon({
          iconUrl: settingObj.img_path,
          iconSize: [36, 36]
        })
        let marker = L.marker([trackObj.lat,trackObj.lng],
          {
            icon: myIcon,
            draggable:false
          }
        )
        let popUpContents = ""
        popUpContents += "<div>車両名："+settingObj.name+"</div>"
        popUpContents += "<div>更新日時："+trackObj.datetime+"</div>"
        //履歴ライン
        let polyline = L.polyline(JSON.parse(carsData.lines),{color: settingObj.color})
        var _this = this
        polyline.on('mouseover',function(e){
          L.popup()
            .setLatLng(e.latlng)
            .setContent(popUpContents)
            .openOn(_this.map)
        })
        this.polyLines.addLayer(polyline)
        this.carMarkers.addLayer(marker)
        marker.bindPopup(popUpContents,
          {
            autoClose:false,
            closeOnClick:false,
            keepInView:true,
            autoPan:false
          }
        ).openPopup()
      })
      this.addCarsMap()
    },
    addCarsMap(){
      if(this.isCarShow) {
        this.map.addLayer(this.carMarkers)
        this.map.addLayer(this.polyLines)
      }else{
        this.map.removeLayer(this.carMarkers)
        this.map.removeLayer(this.polyLines)
      }
    },
    mapClear(){
      this.taskLayers.clearLayers()
      this.map.setView(L.latLng( this.user.location.lat, this.user.location.lng ), 15)
    }
  },
}
</script>

<style scoped>

#map {
  width: 100%;
  height: calc(100vh - 160px);
}

</style>